/**
 * AMQ Footer Menu accordion (AM Quality footer feature).
 *
 * Wraps the <details> of blocks/amq_footer_menu.liquid. Horizon's own accordion-custom component
 * folds below 750px; the footer switches to its mobile layout at 990px (like the header), so this
 * wrapper does the same job with a 990px media query:
 *   - >= 990px: the <details> is open and the summary does not toggle it (static column)
 *   - <  990px: a normal accordion, closed by default
 *   - data-static (block setting "show as accordion" off): always open, never toggles
 *
 * Progressive enhancement like the stock block: the markup ships closed, so without JavaScript
 * the links are behind the native <details> toggle at every width.
 */
class AmqFooterAccordion extends HTMLElement {
  #desktop = matchMedia('(min-width: 990px)');
  #controller = new AbortController();

  connectedCallback() {
    const { signal } = this.#controller;

    this.#applyState();
    this.#desktop.addEventListener('change', this.#applyState, { signal });
    this.querySelector('summary')?.addEventListener('click', this.#handleClick, { signal });
  }

  disconnectedCallback() {
    this.#controller.abort();
  }

  get #isStatic() {
    return this.#desktop.matches || this.hasAttribute('data-static');
  }

  #applyState = () => {
    const details = this.querySelector('details');
    if (details instanceof HTMLDetailsElement) details.open = this.#isStatic;
  };

  /** @param {Event} event */
  #handleClick = (event) => {
    if (this.#isStatic) event.preventDefault();
  };
}

if (!customElements.get('amq-footer-accordion')) {
  customElements.define('amq-footer-accordion', AmqFooterAccordion);
}
